<template>
  <w-setting-sliding-popup v-loading="isLoading" ref="slidingPopup" :title="rtuTitle" width="500px">
    <div slot="content">
      <el-form ref="rtuForm" :rules="rules" :model="data">
        <div class="title-h4 title-bar">기본 정보</div>
        <el-form-item prop="objName" label="수집 장비명">
          <el-input ref="namefield" v-model="data.objName" placeholder="장비명을 입력해주세요."></el-input>
        </el-form-item>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item prop="ipaddressApplyType" label="IP 타입">
              <el-select style="width:100%" @change="changeIpSelect" v-model="data.ipaddressApplytype">
                <el-option label="IPv4" value="IPv4"></el-option>
                <el-option label="IPv6" value="IPv6"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ipaddress" label="IP 주소">
              <el-input ref="ipfield" v-model="data.ipaddress" placeholder="IP주소값을 입력해주세요."></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item label="TCP 포트" prop="alivecheckTcpPort">
              <el-input v-model="data.alivecheckTcpPort" placeholder="TCP포트값을 입력해주세요."></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- SNMP포트 -->
        <div class="title-bar mr-t15">
          <div class="mr-r10">SNMP</div>
          <el-switch v-model="data.alivecheckFlagSnmp" @change="requiredToggle" :active-value="1" :inactive-value="0"></el-switch>
        </div>
        <div v-show="data.alivecheckFlagSnmp == 1">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="SNMP 버전" prop="snmpVersion">
                <el-select v-model="data.snmpVersion" style="width:100%">
                  <el-option v-for="item in snmpVersionList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="SNMP 포트" prop="snmpPort">
                <el-input v-model="data.snmpPort" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-show="data.alivecheckFlagSnmp == 1 && data.snmpVersion != 'V3'">
            <el-col :span="12">
              <el-form-item label="커뮤니티 값" prop="snmpCommunityRead">
                <el-input type="password" v-model="data.snmpCommunityRead" placeholder="입력해 주세요."></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
          <div v-show="data.alivecheckFlagSnmp == 1 && data.snmpVersion == 'V3'">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="USER" prop="snmpV3Username">
                  <el-input v-model="data.snmpV3Username" placeholder="입력해 주세요."></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Context 명" prop="snmpV3ContextName">
                  <el-input v-model="data.snmpV3ContextName" placeholder="입력해 주세요."></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Context ID" prop="snmpV3ContextId">
                  <el-input v-model="data.snmpV3ContextId" placeholder="입력해 주세요."></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="height:25px">
              <el-col :span="12">
                <span>Auth</span>
              </el-col>
              <el-col :span="12">
                <el-row type="flex" justify="end">
                  <el-switch v-model="data.authActiveFlag" :active-value="1" :inactive-value="0"></el-switch>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-show="data.authActiveFlag == '1'">
              <el-col :span="12">
                <el-form-item label="프로토콜" prop="snmpV3AuthProtocol">
                  <el-select v-model="data.snmpV3AuthProtocol" style="width:100%">
                    <el-option v-for="item in snmpAuthList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="비밀번호" prop="snmpV3AuthPassword">
                  <el-input type="password" v-model="data.snmpV3AuthPassword" placeholder="입력해 주세요."></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" style="height:25px">
              <el-col :span="12">
                <span>Privacy</span>
              </el-col>
              <el-col :span="12">
                <el-row type="flex" justify="end">
                  <el-switch v-model="data.privActiveFlag" :active-value="1" :inactive-value="0"></el-switch>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-show="data.privActiveFlag == '1'">
              <el-col :span="12">
                <el-form-item label="프로토콜" prop="snmpV3PrivProtocol">
                  <el-select v-model="data.snmpV3PrivProtocol" style="width:100%">
                    <el-option v-for="item in snmpPrivList" :key="item.basicinfoSubid" :label="item.basicinfoSubname" :value="item.basicinfoSubid"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="비밀번호" prop="snmpV3PrivPassword">
                  <el-input type="password" v-model="data.snmpV3PrivPassword" placeholder="입력해 주세요."></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="popMode === 'add'" type="solid" size="large" @click="onRegistDeviceButton">저장</el-button>
      <el-button v-else size="large" type="solid" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="clickCloseBtn">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import { cloneDeep, isUndefined, assign } from 'lodash';
import { validateIpv4, validateIpv6 } from '@/utils/string';
import msgUtil from '@/utils/message';
import { createEncryptTargetData, getRsaEncrypt } from '@/utils/rsa-encrypt';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import DeviceRegistrationFmsApi from '@/api/settings/common/device-registration-fms';
import DeviceRegistrationCommonAPI from '@/api/settings/common/device-registration-common';

export default {
  name: 'WRtuDeviceUpdateSlidingPopup',
  props: {
    snmpVersionList: Array,
  },
  data() {
    return {
      isLoading: false,
      data: {
        objName: '',
        ipaddressApplytype: 'IPv4',
        ipaddress: '',
        alivecheckTcpPort: '22',
        alivecheckFlagSnmp: '0',
        snmpVersion: 'V1/V2',
        snmpPort: '161',
        snmpCommunityRead: null,
        authActiveFlag: '0',
        privActiveFlag: '0',
        snmpV3AuthProtocol: 'MD5',
        snmpV3AuthPassword: '',
        snmpV3ContextName: '',
        snmpV3PrivProtocol: 'DES',
        snmpV3PrivPassword: '',
        snmpV3Username: '',
        snmpV3ContextId: '',
      },
      snmpAuthList: [],
      snmpPrivList: [],
      dataOrigin: {},
      rtuTitle: '',
      popMode: 'add',
      requireEncryptFields: ['snmpCommunityRead', 'snmpV3AuthPassword', 'snmpV3PrivPassword'],
      rules: {
        objName: {
          required: true,
          trigger: 'blur',
          message: '값을 입력해주세요',
        },
        ipaddress: {
          required: true,
          trigger: 'blur',
          validator: this.validatePassForIp,
        },
        alivecheckTcpPort: {
          required: true,
          trigger: 'blur',
          message: '값을 입력해주세요',
        },
        snmpPort: {
          required: false,
          trigger: 'blur',
          message: '값을 입력해주세요',
        },
      },
    };
  },
  methods: {
    open(item) {
      this.$refs.slidingPopup.open();
      BasicinfoSubAPI.getList('SNMPAUTH').then((response) => {
        this.snmpAuthList = response.data.data;
      });
      BasicinfoSubAPI.getList('SNMPPRIV').then((response) => {
        this.snmpPrivList = response.data.data;
      });
      if (item) {
        this.$nextTick(() => {
          this.rtuTitle = item.objName;
          this.popMode = 'update';
          this.$refs.rtuForm.resetFields();
          this.data = cloneDeep(item);
          this.dataOrigin = cloneDeep(item);
        });
      } else {
        // item 인자가 없는 경우는 RTU 장비 add 팝업창이다.
        this.$nextTick(() => {
          this.$refs.rtuForm.resetFields();
          this.data.alivecheckFlagSnmp = 0;
          this.requiredToggle();
          this.popMode = 'add';
          this.rtuTitle = '수집장비(RTU) 등록';
        });
      }
    },
    // 취소 버튼 클릭
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
    // 해당 함수는 RTU 장비 정보 수정 이벤트이다.
    onSaveButton() {
      this.$refs.rtuForm
        .validate()
        .then((res) => {
          if (res) {
            this.data.objtypeId = 'RTU';
            const target = '수집 장비(RTU)';
            const action = msgUtil.action.SAVE;
            const encryptTargetData = createEncryptTargetData(this.data, this.requireEncryptFields);
            if (encryptTargetData !== null) {
              getRsaEncrypt(encryptTargetData)
                .then((encryptData) => {
                  this.editRtu(assign(cloneDeep(this.data), encryptData), action, target);
                })
                .catch((e) => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                  throw new Error(e);
                });
            } else {
              this.editRtu(this.data, action, target);
            }
          }
        })
        .catch(() => {});
    },
    // 해당 함수는 Rtu 장비 추가 버튼 이벤트이다.
    onRegistDeviceButton() {
      this.$refs.rtuForm
        .validate()
        .then((res) => {
          if (res) {
            this.data.objDefineId = 'FMS_DEVICE';
            this.data.objtypeId = 'RTU';
            const target = '수집 장비(RTU)';
            const action = msgUtil.action.REGIST;
            const encryptTargetData = createEncryptTargetData(this.data, this.requireEncryptFields);
            if (encryptTargetData !== null) {
              getRsaEncrypt(encryptTargetData)
                .then((encryptData) => {
                  this.addRtu(assign(cloneDeep(this.data), encryptData), action, target);
                })
                .catch((e) => {
                  this.$message(msgUtil.getResultMsgData(action, target, false));
                  throw new Error(e);
                });
            } else {
              this.addRtu(this.data, action, target);
            }
          }
        })
        .catch(() => {});
    },
    /**
     * RTU를 추가한다.
     * @param  {[type]} params [description]
     * @param  {[type]} action [description]
     * @param  {[type]} target [description]
     */
    addRtu(params, action, target) {
      this.isLoading = true;
      DeviceRegistrationFmsApi.setFacilityDevice(params)
        .then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.$emit('load-data');
            this.clickCloseBtn();
            this.$message(msgUtil.getResultMsgData(action, target, true));
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * RTU를 수정한다.
     * @param  {[type]} params [description]
     * @param  {[type]} action [description]
     * @param  {[type]} target [description]
     * @return {[type]}        [description]
     */
    editRtu(params, action, target) {
      this.isLoading = true;
      DeviceRegistrationFmsApi.updateFacilityList(params)
        .then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.$emit('load-data');
            this.clickCloseBtn();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // el-select 선택마다 ipfield를 체크한다.
    changeIpSelect() {
      this.$refs.ipfield.focus();
    },
    // IPv4, IPv6에 대한 정규식 유효성 검사
    validatePassForIp(rule, value, callback) {
      const params = {
        objManagetypeId: 'FMS',
        ipaddressApplytype: this.data.ipaddressApplytype,
      };
      if (this.dataOrigin.ipaddress !== this.data.ipaddress) {
        if (isUndefined(value) || value === '') {
          callback(new Error('값을 입력해주세요'));
        } else if (this.data.ipaddressApplytype === 'IPv4') {
          if (validateIpv4(value)) {
            params.ipaddressIpv4 = value;
            DeviceRegistrationCommonAPI.checkIpaddressValidation(params).then((response) => {
              if (response.data.data) {
                callback();
              } else {
                callback(new Error('이미 사용 중인 IP입니다.'));
              }
            });
          } else {
            callback(new Error('IP 주소 형식에 맞게 입력해주십시오.'));
          }
        } else {
          /* eslint-disable no-lonely-if */
          if (validateIpv6(value)) {
            params.ipaddressIpv6 = value;
            DeviceRegistrationCommonAPI.checkIpaddressValidation(params).then((response) => {
              if (response.data.data) {
                callback();
              } else {
                callback(new Error('이미 사용 중인 IP입니다.'));
              }
            });
          } else {
            callback(new Error('IP 주소 형식에 맞게 입력해주십시오.'));
          }
          /* eslint-enable no-lonely-if */
        }
      } else {
        callback();
      }
    },
    // TCP포트와 SNMP포트 작성 input박스에 동적 validation 적용
    requiredToggle(val) {
      if (val) {
        this.rules.snmpPort.required = true;
        this.rules.alivecheckTcpPort.required = false;
      } else {
        this.rules.alivecheckTcpPort.required = true;
        this.rules.snmpPort.required = false;
      }
    },
  },
};
</script>

<style scoped>
.rtu-update-title {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/FacilityDevice/popup/RtuDeviceSlidingPopup.vue